module.exports = __webpack_public_path__ + "img/feature-split-03.403c47fb.jpg";